<div class="preset-selector" *ngIf="client.canUse || client.canManage || selection?.mode === 'preset'">
  <dx-button-group *ngIf="selection" [items]="modeButtons" keyExpr="id" selectionMode="single" stylingMode="contained"
    [disabled]="disabled" [selectedItemKeys]="[selection.mode === 'preset' ? 'preset' : 'custom']"
    [selectedItems]="selectedModeButtons" (onItemClick)="mode($event.itemData.id)"></dx-button-group>
  <div class="field" *ngIf="selection?.mode === 'preset'">
    <div class="label">Hedging Preset</div>
    <div class="preset-choices" [class.preset-choices-vertical]="layout === 'vertical'" role="group" aria-label="Hedging Presets">
      <dx-button *ngFor="let preset of presets; trackBy: trackPreset" [text]="preset.name + (preset.requiresReconfiguration ? ' � Requires Reconfiguration' : '')" width="100%"
        [type]="selection.presetId === preset.id ? 'default' : 'normal'"
        [attr.aria-pressed]="selection.presetId === preset.id ? 'true' : 'false'"
        [disabled]="disabled || loading || !client.canUse || !available || preset.requiresReconfiguration" (onClick)="select(preset.id)"></dx-button>
      <span *ngIf="!loading && available && !presets.length" class="hint preset-no-choices">No Presets Available for This Side.</span>
    </div>
  </div>
  <span *ngIf="loading" class="hint">Loading…</span>
  <div class="preset-error" role="alert" *ngIf="error">{{error}}</div>
</div>

